const en = {
  title: 'BT iPay payments',
  apiUser: 'API username',
  apiPassword: 'API password',
  environment: 'Environment',
  sandbox: 'Sandbox',
  production: 'Production',
  mode: 'Order payment mode',
  onePhase: '1 phase — capture at checkout',
  twoPhase: '2 phases — authorize, then capture on delivery',
  passwordConfigured: 'Password configured. Leave blank to keep it.',
  modeHelp: 'This setting applies to new orders and QR preorders. Bills, selected items, reservations and gift cards use 1 phase.',
  captureHelp: 'Delivering a 2-phase order queues capture. Cancelling queues a reversal or refund after bank verification.',
  refresh: 'Refresh',
  previous: 'Previous',
  next: 'Next',
  page: 'Page',
  empty: 'No BT payments on this page.',
  loadError: 'BT payments could not be loaded. Company-owner or site-admin access is required.',
  saveError: 'BT settings could not be saved.',
  reference: 'Reference / payable',
  amount: 'Card amount',
  approved: 'Authorized',
  capturedAmount: 'Captured',
  returnedAmount: 'Returned',
  state: 'Financial status',
  applied: 'Purchase applied',
  notApplied: 'Purchase not yet applied',
  review: 'Operator review required',
  created: 'Registration unresolved',
  pending: 'Awaiting payment',
  captured: 'Captured',
  failed: 'Failed',
  expired: 'Expired',
  reversed: 'Cancelled / reversed',
  refunded: 'Refunded',
  authorized: 'Authorized — funds reserved',
  partial: 'Partially refunded',
  unknown: 'Unknown',
  refundConfirm: 'Request a BT return? The backend will verify the bank status and reverse the authorization or refund captured funds.',
  returnPending: 'Return requested — awaiting bank confirmation',
  returnHelp: 'This is not a completed refund. Refresh the order or check BT payment history for the verified outcome.',
  details: 'Details',
  close: 'Close',
  transaction: 'Bank transaction',
  environmentLabel: 'Environment',
  cancelRequested: 'Return requested',
  order: 'Order',
  payment: 'Payment',
  processing: 'Processing…',
  fulfilled: 'Fulfillment and financial confirmation are separate.'
}
const ro = {
  title: 'Plăți BT iPay',
  apiUser: 'Utilizator API',
  apiPassword: 'Parolă API',
  environment: 'Mediu',
  sandbox: 'Test',
  production: 'Producție',
  mode: 'Modul de plată al comenzilor',
  onePhase: '1 fază — încasare la plată',
  twoPhase: '2 faze — autorizare, apoi încasare la livrare',
  passwordConfigured: 'Parolă configurată. Lasă câmpul gol pentru a o păstra.',
  modeHelp: 'Setarea se aplică comenzilor și precomenzilor QR noi. Notele, produsele selectate, rezervările și cardurile cadou folosesc 1 fază.',
  captureHelp: 'Livrarea unei comenzi în 2 faze programează încasarea. Anularea programează reversarea sau rambursarea după verificarea băncii.',
  refresh: 'Actualizează',
  previous: 'Înapoi',
  next: 'Înainte',
  page: 'Pagina',
  empty: 'Nu există plăți BT pe această pagină.',
  loadError: 'Plățile BT nu au putut fi încărcate. Este necesar acces de proprietar al companiei sau administrator de site.',
  saveError: 'Setările BT nu au putut fi salvate.',
  reference: 'Referință / achiziție',
  amount: 'Sumă pe card',
  approved: 'Autorizat',
  capturedAmount: 'Încasat',
  returnedAmount: 'Returnat',
  state: 'Stare financiară',
  applied: 'Achiziție confirmată',
  notApplied: 'Achiziție încă neconfirmată',
  review: 'Necesită verificarea unui operator',
  created: 'Înregistrare neconfirmată',
  pending: 'În așteptarea plății',
  captured: 'Încasat',
  failed: 'Eșuat',
  expired: 'Expirat',
  reversed: 'Anulat / reversat',
  refunded: 'Rambursat',
  authorized: 'Autorizat — fonduri rezervate',
  partial: 'Rambursat parțial',
  unknown: 'Necunoscut',
  refundConfirm: 'Soliciți returnarea prin BT? Serverul va verifica starea la bancă și va reversa autorizarea sau rambursa fondurile încasate.',
  returnPending: 'Returnare solicitată — se așteaptă confirmarea băncii',
  returnHelp: 'Rambursarea nu este încă finalizată. Actualizează comanda sau verifică istoricul plăților BT pentru rezultatul confirmat.',
  details: 'Detalii',
  close: 'Închide',
  transaction: 'Tranzacție bancară',
  environmentLabel: 'Mediu',
  cancelRequested: 'Returnare solicitată',
  order: 'Comandă',
  payment: 'Plată',
  processing: 'Se procesează…',
  fulfilled: 'Finalizarea comenzii și confirmarea financiară sunt separate.'
}
export default {en, ro}



// WEBPACK FOOTER //
// ./src/lang/btPayments.js